import React from 'react';
import { Avatar, Col, Row, Typography } from 'components';
import { ManagerModel } from 'models/Manager';

interface IManager {
  role: string;
  data: ManagerModel | undefined;
}

export const Manager = React.memo((props: IManager) => {
  const { role, data } = props;
  return (
    <Row justify={'space-between'}>
      <Col>
        <Typography.Text className={'font-size-16'} type={'secondary'}>
          {role}
        </Typography.Text>
      </Col>
      <Col>
        <Row className={'gap-8'} align={'middle'}>
          <Col>
            <Typography.Text className={'font-size-16'} type={'secondary'}>
              {data?.firstName ? `${data?.firstName} ${data?.lastName}` : 'Not Set'}
            </Typography.Text>
          </Col>
          {data?.firstName && (
            <Col>
              <Avatar src={data?.files?.AVATAR}>
                {data?.firstName?.charAt(0)}
                {data?.lastName?.charAt(0)}
              </Avatar>
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
});
